import Alpine from 'alpinejs'
import focus from '@alpinejs/focus'
import intersect from '@alpinejs/intersect'
import { createIcons, icons } from 'lucide';
import './scripts/scroll-reveal.js';
import './scripts/accessibility';

Alpine.plugin(focus)
Alpine.plugin(intersect)
Alpine.start()

// Inicjalizacja ikon po załadowaniu dokumentu
document.addEventListener('DOMContentLoaded', () => {
    createIcons({
        icons: icons,
    });
});
